import $ from "jquery";
import 'jquery-modal';

class ModalGallery {
    constructor() {
        this.init();
    }

    init() {
        this.dom();
        this.events();
    }

    dom() {
        this.$gallery = $('.gallery');
        this.$galleryImages = this.$gallery.find('img');
        this.$galleryModal = $('.modal-gallery');
        this.$prevArrow = this.$galleryModal.find('.modal-prev');
        this.$nextArrow = this.$galleryModal.find('.modal-next');

        this.currentImageIndex = 0;
    }


    events() {
        this.$galleryImages.on('click.Gallery', this.galleryHandler.bind(this));

        this.$prevArrow.on('click.Gallery', this.showPrevImage.bind(this));

        this.$nextArrow.on('click.Gallery', this.showNextImage.bind(this));
    }

    galleryHandler() {
        const $imageTarget = $(event.target);
        const modalImageUrl = this.getModalImageUrl($imageTarget);

        this.currentImageIndex = this.$galleryImages.index(event.target);

        this.openModal(modalImageUrl);
    }

    openModal(imageUrl) {
        const $modalImg = this.$galleryModal.find('.gallery-modal-img');

        $modalImg.attr('src', imageUrl);

        this.$galleryModal.modal('open');
    }

    showNextImage() {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.$galleryImages.length;
        const modalImageUrl = this.getModalImageUrl(this.$galleryImages.eq(this.currentImageIndex));

        this.openModal(modalImageUrl);
    }

    showPrevImage() {
        this.currentImageIndex = (this.currentImageIndex - 1 + this.$galleryImages.length) % this.$galleryImages.length;
        const modalImageUrl = this.getModalImageUrl(this.$galleryImages.eq(this.currentImageIndex));

        this.openModal(modalImageUrl);
    }

    getModalImageUrl($image) {
        let modalImageUrl = $image.attr('src');

        if ($image.data('modal-src')) {
            modalImageUrl = $image.data('modal-src');
        }

        return modalImageUrl;
    }
}

export default ModalGallery;